module.exports = __webpack_public_path__ + "static/media/step5-back.fd67026a.png";